import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

export const ManagerContext = createContext({});

export function ManagerProvider({ children, ...props }) {
	return <ManagerContext.Provider {...props}>{children}</ManagerContext.Provider>;
}

export function useManagerStore() {
	return useContext(ManagerContext);
}
